import React from 'react';
import { Link } from 'react-router-dom';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';

const TeamExpertise = ({ service }) => {
  return (
    <div className="bg-white rounded-xl shadow-soft border border-border p-8">
      <div className="flex items-center space-x-3 mb-6">
        <div className="w-10 h-10 rounded-full gradient-primary flex items-center justify-center">
          <Icon name="Users" size={20} color="white" />
        </div>
        <div>
          <h3 className="text-lg font-semibold text-foreground">
            Expert Team
          </h3>
          <p className="text-sm text-muted-foreground">
            Meet the specialists behind this service
          </p>
        </div>
      </div>

      <div className="space-y-6">
        {service.teamExperts.map((expert, index) => (
          <div key={index} className="flex items-start space-x-4">
            <div className="w-12 h-12 rounded-full overflow-hidden flex-shrink-0">
              <Image 
                src={expert.avatar}
                alt={expert.name}
                className="w-full h-full object-cover"
              />
            </div>
            
            <div className="flex-1 min-w-0">
              <h4 className="font-semibold text-foreground mb-1">
                {expert.name}
              </h4>
              <p className="text-sm text-primary mb-2">
                {expert.role}
              </p>
              <p className="text-sm text-muted-foreground mb-3">
                {expert.expertise}
              </p>
              
              <div className="flex flex-wrap gap-2">
                {expert.skills.map((skill, skillIndex) => (
                  <span 
                    key={skillIndex}
                    className="text-xs bg-muted text-muted-foreground px-2 py-1 rounded"
                  >
                    {skill}
                  </span>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-6 pt-6 border-t border-border">
        <Link 
          to="/team-profiles"
          className="flex items-center justify-center space-x-2 text-primary hover:text-secondary font-medium transition-smooth"
        >
          <span>Meet Full Team</span>
          <Icon name="ArrowRight" size={16} />
        </Link>
      </div>
    </div>
  );
};

export default TeamExpertise;